import type { Font } from '../types/font';
import { cyrillicExt } from '../types/unicode-range';

export const jetBrainsMonoV18: Font = {
  fontFamily: 'jet-brains-mono-v18',
  displayName: 'JetBrains Mono',
  sources: [
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: cyrillicExt,
      src: 'jet-brains-mono-v18-cyrillic-ext-400italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'jet-brains-mono-v18-cyrillic-400italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'greek',
      src: 'jet-brains-mono-v18-greek-400italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'vietnamese',
      src: 'jet-brains-mono-v18-vietnamese-400italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'jet-brains-mono-v18-latin-ext-400italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'jet-brains-mono-v18-latin-400italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: cyrillicExt,
      src: 'jet-brains-mono-v18-cyrillic-ext-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'jet-brains-mono-v18-cyrillic-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'greek',
      src: 'jet-brains-mono-v18-greek-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'vietnamese',
      src: 'jet-brains-mono-v18-vietnamese-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'jet-brains-mono-v18-latin-ext-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'jet-brains-mono-v18-latin-700italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: cyrillicExt,
      src: 'jet-brains-mono-v18-cyrillic-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'jet-brains-mono-v18-cyrillic-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'greek',
      src: 'jet-brains-mono-v18-greek-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'vietnamese',
      src: 'jet-brains-mono-v18-vietnamese-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'jet-brains-mono-v18-latin-ext-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'jet-brains-mono-v18-latin-regular.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: cyrillicExt,
      src: 'jet-brains-mono-v18-cyrillic-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'jet-brains-mono-v18-cyrillic-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'greek',
      src: 'jet-brains-mono-v18-greek-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'vietnamese',
      src: 'jet-brains-mono-v18-vietnamese-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'jet-brains-mono-v18-latin-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'jet-brains-mono-v18-latin-700.woff2',
      format: 'woff2',
    },
  ],
};
